import React from 'react';

interface IInviteUser {
  setInviteFailMode: any;
  handleTabChange: any;
}

const InviteFailModal: React.FC<IInviteUser> = ({
  setInviteFailMode,
  handleTabChange,
}) => {
  return (
    <div className='invite-fail-container'>
      <div className='invite-fail-icon'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
        >
          <g clipPath='url(#clip0_4359_981)'>
            <path
              d='M10 13.3334V10M10 6.66669H10.0084M18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C14.6024 1.66669 18.3334 5.39765 18.3334 10Z'
              stroke='#F79009'
              strokeWidth='1.66667'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_4359_981'>
              <rect width='20' height='20' fill='white' />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className='invite-fail-content'>
        <div className='invite-fail-text-group'>
          <div className='invite-fail-text-wrap'>
            <div className='invite-fail-text-primary'>
              Must purchase additional seats.
            </div>
          </div>
          <div className='invite-fail-text-secondary'>
            Visit the Plans page to manage your subscription.
          </div>
        </div>
        <div className='invite-fail-actions'>
          <div
            className='invite-fail-action-btn'
            onClick={() => setInviteFailMode(false)}
          >
            <div className='invite-fail-action-dismiss'>Dismiss</div>
          </div>
          <div
            className='invite-fail-action-btn'
            onClick={() => handleTabChange('Plans')}
          >
            <div className='invite-fail-action-upgrade'>Upgrade Plan</div>
          </div>
        </div>
      </div>
      <div
        className='invite-fail-close'
        onClick={() => setInviteFailMode(false)}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
        >
          <path
            d='M15 5L5 15M5 5L15 15'
            stroke='#85888E'
            strokeWidth='1.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
    </div>
  );
};

export default InviteFailModal;
